import React, { Component, Fragment } from 'react';

import { Link, withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';

import TextField from '../../artzu-ui/src/TextField';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import Header from './PasswordHeader';
import SideBarContent from '../SideBar/SideBarContent';
import Footer from './UpdatePasswordFooter';

const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($oldPwd: String!, $newPwd: String!) {
    updatePassword(oldPassword: $oldPwd, newPassword: $newPwd) {
      status
    }
  }
`;
class UpdatePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oldPassword: '',
      password: '',
      passwordConfirm: '',
      oldPasswordError: '',
      passwordError: '',
      passwordConfirmError: '',
      modal: false
    };
  }

  handleInputChange = (key, value) => {
    this.setState({ [key]: value });
  };

  validatePasswords = () => {
    const { password, passwordConfirm } = this.state;
    let passwordError = '';
    let passwordConfirmError = '';
    let oldPasswordError = '';
    if (password.length < 8) {
      passwordError = 'Password must be 8 characters or more';
    }
    if (password !== passwordConfirm) {
      passwordConfirmError = 'Passwords must match';
    }
    this.setState({
      oldPasswordError,
      passwordError,
      passwordConfirmError
    });

    return !(oldPasswordError || passwordError || passwordConfirmError);
  };

  onClick = () => {
    if (this.validatePasswords()) {
      const { oldPassword, password } = this.state;
      this.props.client
        .mutate({
          mutation: UPDATE_PASSWORD,
          variables: {
            oldPwd: oldPassword,
            newPwd: password
          }
        })
        .then(({ data }) => data.updatePassword.status)
        .then(status => {
          if (status === 'success') {
            this.setState({ modal: true });
          } else {
            this.setState({
              oldPasswordError: "Old password isn't valid."
            });
          }
        });
    }
  };

  render() {
    const { history, status, loggedIn } = this.props;
    const {
      oldPassword,
      password,
      passwordConfirm,
      oldPasswordError,
      passwordError,
      passwordConfirmError,
      modal
    } = this.state;
    return (
      <Fragment>
        <div className="apply__progress--header">
          <Header
            title="My Profile"
            persistentTitle
            back
            disable
            onClick={() => history.goBack()}
            onClickSave={() => this.onClick()}
          />
        </div>

        <div className="profile__body container">
          <div className="profile__container">
            <div className="profile__sidebar">
              <SideBarContent status={status} signedIn={loggedIn} />
            </div>
            <div className="profile__user--container">
              {/* <div className=""> */}
              <div className="update-password__title">Change Password</div>
              <div className="">
                <div className="update-password__textfield">
                  <TextField
                    heading="Old Password"
                    value={oldPassword}
                    error={oldPasswordError}
                    className="update-password__textfield--font"
                    password
                    width="100%"
                    onChange={e =>
                      this.handleInputChange('oldPassword', e.target.value)
                    }
                  />
                </div>
                <div className="update-password__textfield">
                  <TextField
                    heading="New Password"
                    value={password}
                    error={passwordError}
                    className="update-password__textfield--font"
                    password
                    width="100%"
                    // style={{ 'margin-bottom': '0.7em' }}
                    onChange={e =>
                      this.handleInputChange('password', e.target.value)
                    }
                  />
                </div>
                <div className="update-password__textfield">
                  <TextField
                    heading="Confirm New Password"
                    value={passwordConfirm}
                    error={passwordConfirmError}
                    className="update-password__textfield--font"
                    password
                    width="100%"
                    onChange={e =>
                      this.handleInputChange(
                        'passwordConfirm',
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
              <Modal open={modal}>
                <div className="update-password__modal">
                  <div className="">
                    You password has been changed successfully!
                  </div>
                  <Link
                    to="/profile"
                    className="update-password__modal--padding">
                    <Button
                      label="Profile"
                      className="update-password__modal__button"
                      color="#128DFF"
                    />
                  </Link>
                </div>
              </Modal>
              <Footer
                label={'Save'}
                back
                active
                onBackClick={() => history.goBack()}
                onNextClick={this.onClick}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(withApollo(UpdatePassword));



// WEBPACK FOOTER //
// ./src/components/UpdatePassword/UpdatePassword.js